import apiClient from './client';

// How basic or advanced (1-9) knowledge of a disease, finding or association is.
// `kind` is "diseases", "findings" or "associations". Both calls return the new
// stats, {average, count, my_rating}.

export const rateKnowledge = (kind, id, knowledge) =>
  apiClient.put(`/${kind}/${id}/knowledge-rating`, { knowledge }).then((r) => r.data);

export const clearKnowledgeRating = (kind, id) =>
  apiClient.delete(`/${kind}/${id}/knowledge-rating`).then((r) => r.data);
